// extracted by mini-css-extract-plugin
export default {"copy-button":"CopyableTextInputField__copy-button__KHz3G","copyButton":"CopyableTextInputField__copy-button__KHz3G"};